import { PayloadAction } from "@reduxjs/toolkit";
import { Message } from "../../../../utl/models/Message";
import { LocationsState } from "../models/LocationsState";

const setMessage = (state: LocationsState, action: PayloadAction<Message>) => {
    state.message = action.payload.message;
}

export default setMessage;